import { Fragment, useEffect, useState } from "react";
import ModalComponent from "../modal";
import ButtonComponent from "../button";
import CardSecondaryComponent from "../card-secondary";
import ViewDetailsTable from "../view-details-table";
import styled from "styled-components";
import { AuthPageHead } from "../../styles/global-styles";
import TabsComponent from "../tabs";
import { AuthHistoryTabConstant } from "../../constants/app-constants";
import EmptyModalComponent from "../empty-modal";
import { EmptyModalWrapper } from "../empty-modal/empty-modal.style";
import CardsSecondaryComponent from "../cards-secondary";

const AuthHistoryModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const ViewHistoryModal = ({ data, logs, close, label, slide }) => {
    const tabs = [
        {
            label: 'Transaction Logs', value: AuthHistoryTabConstant?.transactionLogs
        },
        {
            label: 'mPay Logs', value: AuthHistoryTabConstant?.mPayLogs
        },
        // ...(logs?.mpayLogs?.length > 0 ? [{
        //     label: 'MPay Logs', value: AuthHistoryTabConstant?.mPayLogs
        // }] : []),
        {
            label: 'Audit Logs', value: AuthHistoryTabConstant?.auditLogs
        },
        {
            label: 'Risk Scoring Logs', value: AuthHistoryTabConstant?.riskScoringLogs
        }
    ];

    const initialStates = {
        selected: null,
        selectedLabel: null,
        selectedMPay: null,
        isView: false,
        selectedTab: AuthHistoryTabConstant?.transactionLogs,
    };

    const [states, setStates] = useState(initialStates);
    const [logData, setLogData] = useState([]);
    const [mpayLogData, setMpayLogData] = useState([]);
    const [selectedRiskSection, setSelectedRiskSection] = useState(null);

    const handleSelect = (log) => {
        if (states.selectedTab === AuthHistoryTabConstant?.mPayLogs) {
            setStates((old) => ({ ...old, selectedMPay: log, selectedLabel: log?.apiName, isView: true }));
        } else {
            setStates((old) => ({ ...old, selected: log?.log, selectedLabel: log?.logType, isView: true }));
        }
    };

    const handleBack = () => {
        setStates((old) => ({
            ...old,
            selected: null,
            selectedLabel: null,
            selectedMPay: null,
            isView: false
        }));
    };

    useEffect(() => {
        if (data && Object.entries(data).length > 0) {
            const logOrder = [
                'areqlog', 'areqlogs',
                'areslog', 'areslogs',
                'creqlog', 'creqlogs',
                'creslog', 'creslogs',
            ];
            const dataArray = Object.entries(data).map(([key, value]) => ({
                logType: key,
                log: value
            }));
            dataArray.sort((a, b) => {
                const aIndex = logOrder.indexOf(a.logType.toLowerCase());
                const bIndex = logOrder.indexOf(b.logType.toLowerCase());
                const aPriority = aIndex === -1 ? logOrder.length : aIndex;
                const bPriority = bIndex === -1 ? logOrder.length : bIndex;
                if (aPriority !== bPriority) return aPriority - bPriority;
                return 0;
            });
            setLogData(dataArray);
        }
    }, [data]);

    useEffect(() => {
        if (logs?.mpayLogs && Array.isArray(logs.mpayLogs)) {
            setMpayLogData(logs.mpayLogs);
        }
    }, [logs]);

    return (
        <ModalComponent close={close} label={label} width={1200} slide={slide}>
            <TabsComponent
                tabs={tabs}
                value={states.selectedTab}
                onChange={(value) => { setStates({ ...initialStates, selectedTab: value }); setSelectedRiskSection(null); }}
            >
                {
                    states.selectedTab === AuthHistoryTabConstant?.transactionLogs && logData && logData.length > 0 &&
                    <AuthHistoryModalWrapper>
                        {
                            logData.map((log, index) => (
                                <Fragment key={index}>
                                    {
                                        !states.isView && log?.log &&
                                        <CardSecondaryComponent label={log?.logType} data={log?.log} handleClick={() => handleSelect(log)} />
                                    }
                                </Fragment>
                            ))
                        }
                        {
                            states.isView && states.selected &&
                            <div>
                                <AuthPageHead style={{ marginBottom: '10px' }}>
                                    <div className="left">
                                        <h5 style={{ textTransform: 'capitalize' }}>{states.selectedLabel} Detailed view</h5>
                                    </div>

                                    <div className="right">
                                        <ButtonComponent label="Back to logs" size="small" outline onClick={handleBack} />
                                    </div>
                                </AuthPageHead>
                                <ViewDetailsTable
                                    data={Object.entries(states.selected).map(([key, value]) => ({
                                        label: key,
                                        value: value
                                    }))}
                                />
                            </div>
                        }
                    </AuthHistoryModalWrapper>
                }

                {
                    states.selectedTab === AuthHistoryTabConstant?.mPayLogs && (
                        <AuthHistoryModalWrapper>
                            {
                                !states.isView && (
                                    mpayLogData?.length > 0 ? (
                                        mpayLogData.map((log, index) => (
                                            <Fragment key={index}>
                                                <CardSecondaryComponent
                                                    label={log?.apiName || `Log #${index + 1}`}
                                                    data={log}
                                                    handleClick={() => handleSelect(log)}
                                                />
                                            </Fragment>
                                        ))
                                    ) : (
                                        <EmptyModalWrapper>
                                            <EmptyModalComponent text="No mPay logs found!" />
                                        </EmptyModalWrapper>
                                    )
                                )
                            }

                            {
                                states.isView && states.selectedMPay && (
                                    <div>
                                        <AuthPageHead style={{ marginBottom: '10px' }}>
                                            <div className="left">
                                                <h5 style={{ textTransform: 'capitalize' }}>
                                                    {states.selectedLabel || states.selectedMPay?.apiName} Detailed view
                                                </h5>
                                            </div>

                                            <div className="right">
                                                <ButtonComponent label="Back to logs" size="small" outline onClick={handleBack} />
                                            </div>
                                        </AuthPageHead>

                                        <ViewDetailsTable
                                            data={Object.entries(states.selectedMPay).map(([key, value]) => ({
                                                label: key,
                                                value: (() => {
                                                    try {
                                                        const parsed = JSON.parse(value);
                                                        return JSON.stringify(parsed, null, 2);
                                                    } catch {
                                                        return typeof value === "object"
                                                            ? JSON.stringify(value, null, 2)
                                                            : value;
                                                    }
                                                })()
                                            }))}
                                        />
                                    </div>
                                )
                            }
                        </AuthHistoryModalWrapper>
                    )
                }

                {
                    states?.selectedTab === AuthHistoryTabConstant?.auditLogs &&
                    <AuthHistoryModalWrapper>
                        {
                            logs?.transactionAuditLogs && Object.entries(logs?.transactionAuditLogs)?.length > 0 ? (
                                <ViewDetailsTable
                                    data={Object.entries(logs?.transactionAuditLogs).map(([key, value]) => ({
                                        label: key,
                                        value: value
                                    }))}
                                />
                            ) : (
                                <EmptyModalWrapper>
                                    <EmptyModalComponent text="No audit logs found!" />
                                </EmptyModalWrapper>
                            )
                        }
                    </AuthHistoryModalWrapper>
                }
                {
                    states?.selectedTab === AuthHistoryTabConstant?.riskScoringLogs &&
                    <AuthHistoryModalWrapper>
                        {
                            logs?.riskScoring && Object.keys(logs?.riskScoring)?.length > 0 ? (
                                (() => {
                                    const riskScoringData = logs.riskScoring;

                                    const riskSections = {
                                        generalInfo: {

                                            data: {
                                                'ACS Transaction ID': riskScoringData.acsTransId,
                                                'Card Number': riskScoringData.cardNumber,
                                                'Merchant Name': riskScoringData.merchantName,
                                            }
                                        },
                                        finalDecision: {
                                            data: {
                                                'overall Risk Score': <span style={{ fontSize: '24px', color: 'var(--text-color-primary)', fontWeight: 'bold' }}>{riskScoringData?.overallRiskScore}</span>,
                                                'Risk Decision': riskScoringData?.riskDecision,
                                            }
                                        },
                                        transactionRisk: {
                                            label: 'Transaction Risk',
                                            showBadge: true,
                                            badgeLabel: 'Applied',
                                            badgeType: 'success',
                                            data: {
                                                'Successful Transaction': riskScoringData.successfulTransactionCount,
                                                'Lookback Days': riskScoringData.lookbackDays,
                                                'Risk Level': riskScoringData.transactionRiskLevel,
                                                'Score': riskScoringData.transactionScore,
                                                'Weight': riskScoringData.transactionWeightage,
                                                'Weighted Contribution': riskScoringData.transactionRiskScore,
                                            }
                                        },
                                        amountRisk: {
                                            label: 'Amount Risk',
                                            showBadge: true,
                                            badgeLabel: riskScoringData.amountRiskScore > 0 ? 'Applied' : 'Not Applied',
                                            badgeType: riskScoringData.amountRiskScore > 0 ? 'success' : 'error',
                                            data: {
                                                'Purchase Amount': riskScoringData.purchaseAmount,
                                                'Risk Level': riskScoringData.amountRiskLevel,
                                                'Score': riskScoringData.amountScore,
                                                'Weight': riskScoringData.amountWeightage,
                                                'Weighted Contribution': riskScoringData.amountRiskScore,
                                            }
                                        },
                                        currencyRisk: {
                                            label: 'Currency Risk',
                                            showBadge: true,
                                            badgeLabel: riskScoringData.currencyRiskScore > 0 ? 'Applied' : 'Not Applied',
                                            badgeType: riskScoringData.currencyRiskScore > 0 ? 'success' : 'error',
                                            data: {
                                                'Purchase Currency': riskScoringData.purchaseCurrency,
                                                'Score': riskScoringData.currencyScore,
                                                'Weight': riskScoringData.currencyWeightage,
                                                'Weighted Contribution': riskScoringData.currencyRiskScore,
                                            }
                                        },
                                        fingerprintRisk: {
                                            label: 'Device Fingerprint Risk',
                                            showBadge: true,
                                            badgeLabel: riskScoringData.fingerprintRiskScore > 0 ? 'Applied' : 'Not Applied',
                                            badgeType: riskScoringData.fingerprintRiskScore > 0 ? 'success' : 'error',
                                            data: {
                                                'Device Fingerprint': riskScoringData.deviceFingerprint,
                                                'Transaction From This Device': riskScoringData.matchingFingerprintTransactionCount,
                                                'Score': riskScoringData.fingerprintScore,
                                                'Weight': riskScoringData.fingerprintWeightage,
                                                'Weighted Contribution': riskScoringData.fingerprintRiskScore,
                                            }
                                        }
                                    };

                                    const section = selectedRiskSection ? riskSections[selectedRiskSection] : null;

                                    return (
                                        <>
                                            {
                                                !selectedRiskSection && Object.entries(riskSections).map(([key, sec]) => (
                                                    <CardsSecondaryComponent
                                                        key={key}
                                                        label={sec.label}
                                                        data={sec.data}
                                                        hideButton={Object.keys(sec.data).length <= 6}
                                                        handleClick={() => setSelectedRiskSection(key)}
                                                        showBadge={sec.showBadge}
                                                        badgeLabel={sec.badgeLabel}
                                                        badgeType={sec.badgeType}
                                                    />
                                                ))
                                            }
                                            {
                                                selectedRiskSection && section && (
                                                    <div>
                                                        <AuthPageHead style={{ marginBottom: '10px' }}>
                                                            <div className="left">
                                                                <h5 style={{ textTransform: 'capitalize' }}>{section.label}</h5>
                                                            </div>
                                                            <div className="right">
                                                                <ButtonComponent label="Back to Risk Scoring" size="small" outline onClick={() => setSelectedRiskSection(null)} />
                                                            </div>
                                                        </AuthPageHead>
                                                        <ViewDetailsTable
                                                            data={Object.entries(section.data).map(([key, value]) => ({
                                                                label: key,
                                                                value: value
                                                            }))}
                                                        />
                                                    </div>
                                                )
                                            }
                                        </>
                                    );
                                })()
                            ) : (
                                <EmptyModalWrapper>
                                    <EmptyModalComponent text="No Risk Scoring logs found!" />
                                </EmptyModalWrapper>
                            )
                        }
                    </AuthHistoryModalWrapper>
                }
            </TabsComponent>
        </ModalComponent>
    );
};

export default ViewHistoryModal;
